import { createSelector } from "reselect"
import { chain, pickBy, isEmpty, map, merge } from "lodash"
import { getAllItems, getOrderedCategoryItems } from "./items"
import { getFavoriteFactors } from "modules/portfolio-root/selectors/portfolios"
import { getPerformanceHistory } from "./performance"
import { COLORS, ANALYZE_FACTORS_TAKE, MANDATORY_PERFORMANCE_METRICS } from "helpers/analyzeConstants"
import { computePerformanceData, computeDisplayCategories, computeNonZerosKeys } from "helpers/analyze"

const EMPTY_ARRAY = []

export const getData = createSelector(
  [getAllItems, getPerformanceHistory],
  computePerformanceData,
)

const getOverrideKeys = createSelector(
  [getFavoriteFactors],
  (favoriteFactors) => merge(MANDATORY_PERFORMANCE_METRICS, favoriteFactors),
)

const getNonZerosKeys = createSelector(
  [getData, getOverrideKeys],
  computeNonZerosKeys,
)

export const getCategoryItemsSubset = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  (items, keys) =>
    chain(items)
      .filter(item => keys[item.id])
      .take(ANALYZE_FACTORS_TAKE + 1) // 1 category total item + X items
      .map((item, index) => ({
        ...item,
        color: item.color || COLORS[index - 1], // Ignore to the total item color
      }))
      .value(),
)

export const getFilteredData = createSelector(
  [getData, getNonZerosKeys, getCategoryItemsSubset],
  (data, keys, items) => isEmpty(items) ? EMPTY_ARRAY : map(data, item => pickBy(item, (item, key) => keys[key])),
)
export const getDisplayCategories = createSelector(
  [getAllItems, getNonZerosKeys],
  computeDisplayCategories,
)
